window.Parsley.addCatalog(
    "it",
    {
        defaultMessage: "Questo valore sembra non essere valido.",
        type: {
            email: "Questo valore deve essere un'e-mail valida.",
            url: "Questo valore deve essere un URL valido.",
            urlstrict: "Questo valore deve essere un URL valido.",
            number: "Questo valore deve essere un numero valido.",
            integer: "Questo valore deve essere un numero valido.",
            digits: "Questo valore deve essere una cifra valida.",
            dateIso:
                "Questo valore deve essere una data nel seguente formato: (AAAA-MM-GG).",
            alphanum: "Questo valore deve essere alfanumerico.",
            phone: "Questo valore deve essere un numero di telefono valido",
        },
        notnull: "Questo valore non deve essere vuoto.",
        notblank: "Questo valore non deve essere vuoto.",
        required: "Questo valore è obbligatorio.",
        regexp: "Questo valore non è corretto.",
        pattern: "Questo valore non è corretto.",
        min: "Questo valore non deve essere inferiore a %s.",
        max: "Questo valore non deve essere superiore a %s.",
        range: "Questo valore deve essere compreso tra %s e %s.",
        minlength:
            "Questo valore è molto corto. La lunghezza minima è di %s caratteri.",
        maxlength:
            "Questo valore è molto lungo. La lunghezza massima è di %s caratteri.",
        length: "La lunghezza di questo valore deve essere compresa tra %s e %s caratteri.",
        mincheck: "È necessario selezionare almeno %s opzioni.",
        maxcheck: "È necessario selezionare %s opzioni o meno.",
        check: "È necessario scegliere tra le opzioni %s e %s.",
        rangecheck: "È necessario selezionare tra %s e %s opzioni.",
        rangelength: "Questo valore deve essere lungo tra %s e %s caratteri.",
        equalto: "Questo valore deve essere identico.",
    },
    true
);
